export default class Fulfillment
{
	id = null
	requestedOn = null

	userId = null
	type = null
	
	shippingDetails = null

	status = null;
	dispatchedOn = null
}